module.exports = __webpack_public_path__ + "img/m-process-settings.451a1ef7.svg";